import React from 'react';
import { Link } from 'react-router-dom';

const RecentlyViewed = ({ items, currentProductId }) => {
  const filtered = items.filter((p) => p._id !== currentProductId);
  if (filtered.length === 0) return null;

  return (
    <div className="mt-5">
      <h5 className="mb-3">Recently Viewed</h5>
      <div className="d-flex gap-3 overflow-auto pb-2" style={{ scrollbarWidth: 'thin' }}>
        {filtered.map((product) => (
          <Link
            key={product._id}
            to={`/products/${product.slug || product._id}`}
            className="text-decoration-none text-dark flex-shrink-0"
            style={{ width: '150px' }}
          >
            <div className="rounded overflow-hidden border" style={{ height: '150px' }}>
              {product.image ? (
                <img src={product.image} alt={product.name} className="w-100 h-100" style={{ objectFit: 'cover' }} />
              ) : (
                <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                  <small className="text-muted">No Image</small>
                </div>
              )}
            </div>
            <p className="small mt-2 mb-0 text-truncate">{product.name}</p>
            <p className="small fw-bold text-primary mb-0">${product.price?.toFixed(2)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;
